import { Timestamp, collection, doc, getDoc, getDocs, orderBy, query, startAfter, where } from "firebase/firestore";
// import firebase from 'firebase'
import { firestore as db, firestore } from "../../firebaseConfig";
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
];


export const getProductsPerRange = async (name, start, end) => {
    try {
        const getProducts = await fetch(
            `https://us-central1-expertminute-net.cloudfunctions.net/adminApi/getAnalysisStore?name=${name}`,
            {
                method: "POST",
                body: JSON.stringify({
                    start,
                    end,
                }),
            }
        );
        const productsRes = await getProducts.json();
        // console.log(productsRes.data,"allData filter");
        if (productsRes.isSuccess) {
            const carts = productsRes.data.cart;
            return { data: carts, error: false }
        } else {
            throw new Error()
        }
    } catch (e) {
        return { data: null, error: true }
    }
}
export const getMinutesByRange = async (name, start, end) => {
    try {
        const allminutesReq = await fetch(
            `https://us-central1-expertminute-net.cloudfunctions.net/adminApi/getAnalysisAllUser?name=${name}`,
            {
                method: "POST",
                body: JSON.stringify({
                    start,
                    end,
                }),
            }
        );
        const minutesRes = await allminutesReq.json();
        if (minutesRes.isSuccess) {
            const minutes = minutesRes.data.userData;
            return { data: minutes, error: false };
        } else {
            return { data: null, error: true }
        }
    } catch (e) {
        return { data: null, error: true }
    }
}
export const getAnalysisyearly = async (name, year) => {
    // try {
    // console.log(name, year, "name,year getAaylsis")
    const current = new Date();
    let endIndx = 12
    let month = 0;
    let data = []
    if (year == "Last 6 months") {
        endIndx = 6
        month = current.getMonth()
        year = current.getFullYear()
    } else if (current.getFullYear() === year) {
        endIndx = current.getMonth() + 1;
        month = current.getMonth();
    } else {
        endIndx = 12;
        month = 11;
    }

    let end = new Date()
    let highest = { q: 0, s: 0 }
    const labels = []
    const yearDocs = []
    // console.log("asydhjh",)
    for (let i = 0; i < endIndx; i++) {
        // const start = new Date(year, month - i, 1, 0, 0, 0);
        const start = new Date(year, month - i, 1, 0, 0, 0);
        // console.log("month",start)
        let newMonth = start.getMonth() + 1
        // console.log("month",month)
        newMonth = (newMonth < 10) ? '0' + newMonth.toString() : newMonth.toString();
        // console.log("month", newMonth, name, start.getFullYear())
        const docRef = doc(db, `stores/${name}/analysis/${start.getFullYear()}/${newMonth}/allAnalysis`);
        // console.log(q, "wuery")
        // if(q)
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const data = docSnap.data()
            yearDocs.push(data);
            labels.push(months[start.getMonth()])
        } else {
            yearDocs.push({
                totalAmount: 0,
                totalQuantity: 0,
                totalMinutes: 0,
            })
            labels.push(months[start.getMonth()])
        }





    }
    
    let sales = []
    let quantity = []
    let minutes = []
    for (let item of yearDocs) {
        sales.push(item.totalAmount)
        quantity.push(item.totalQuantity)
        minutes.push(item.totalMinutes)
    }
    return { data: yearDocs, labels, sales, minutes, quantity, error: false }
    // } catch (e) {
    //     return { data: null, error: true }
    // }
}

export const getAllSubsByY = async (store, beg, en,year) => {
    try {
        const list = []
        let obj = {}

        obj[store] = []
        // list of sum of subs on specific month and total money ;
        const mons = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, };
        const current = new Date();
        const thisYear = new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0)
        // const end = current.toISOString()
        // const start = thisYear.toISOString();
        // console.log("here",thisMonth)
        var start = new Date(year, 0, 1).toISOString();
        var end = new Date(year, 11, 31).toISOString();
        const q = query(collection(db, `stores/${store}/subscription`),
            where("created_at",">=",start),
            where("created_at","<=",end),
            orderBy("created_at"),
            // startAfter(startafter)
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
        } else {
            // console.log(startDate, endDate)
            querySnapshot.forEach((doc) => {
                const sub = doc.data()
                const creation = new Date(sub.created_at)
                mons[creation.getMonth()] += (+sub.plan.pricePlan)

            })
        }
        let arr = []
        // arr.slice(start,end)

        for (let i in mons) {
            arr[i] = mons[i]
        }
        // console.log(arr,"months")
        return { data: arr.slice(beg, en), labels: months.slice(beg, en), error: false }
    } catch (e) {
        return { data: null, error: true }
    }
}
export const getCancelledSubs=async(store,period="tm")=>{
    try {
        const current=new Date();
        const month=current.getMonth()
        let start;
        let end;
        if(period=="tm"){
            end = current;
            start = new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0);
        }else{
            start = new Date(current.getFullYear(), month - 1, 1, 0, 0, 0);
            end = new Date(current.getFullYear(), month, 0, 23, 59, 59);
        }
        
        // const startOfDay = Timestamp.fromDate(data)
        // startOfDay.setHours(0, 0, 0, 0);
        // console.log(Timestamp.fromDate(start), Timestamp.fromDate(end))
        const q = query(collection(db, `stores/${store}/subscription`),
            where("dateCanceled", ">=", Timestamp.fromDate(start)),
            where("dateCanceled", "<=", Timestamp.fromDate(end)),
            orderBy("dateCanceled"),
            // startAfter(startafter)
        );
        const snapshots=await getDocs(q)
        let count=0;
        const list=[]
        snapshots.forEach(doc=>{
            list.push(doc.data())
            count++
        })
    } catch (e) {
        // console.log(e.message,"error on getSubsTM")
        return {error:true,data:null}
    }
}
getCancelledSubs("ExpertMinute-Dev")
export const getwholeAnalysis = async (store) => {
    try {
        const docRef = doc(db, `stores/${store}/analysis/allAnalysis`);
        // console.log(q, "wuery")
        // if(q)
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const { totalAmount, totalCall: totalCalls, totalQuantity, totalMinutes } = docSnap.data()
            return {
                data: {
                    totalAmount:totalAmount||0,
                    totalQuantity:totalQuantity||0,
                    totalMinutes:totalMinutes||0,
                    totalCalls:totalCalls||0,
                },
                error:false,
            }
        } else {
            return ({
                data: {
                    totalAmount: 0,
                    totalQuantity: 0,
                    totalMinutes: 0,
                    totalCalls: 0,
                },
                error: false

            })
        }
    } catch (e) {
        // console.log(e.message);
        return {error:true,data:null}
    }
}
export const getAllstoresAnalysis=async()=>{
    try {
        const docRef = doc(db, `allAnalysis/allAnalysis`);
        // console.log(q, "wuery")
        // if(q)
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const { totalAmount, totalCall: totalCalls, totalQuantity, totalMinutes } = docSnap.data()
            return {
                data: {
                    totalAmount,
                    totalQuantity,
                    totalMinutes,
                    totalCalls,
                },
                error: false,
            }
        } else {
            return ({
                data: {
                    totalAmount: 0,
                    totalQuantity: 0,
                    totalMinutes: 0,
                    totalCalls: 0,
                },
                error: false

            })
        }
    } catch (e) {
        return {data:null,error:false}
    }
}
const isInRange = (date, start, end) => {
    start = new Date(start);
    end = new Date(end);
    // second.setDate(second.getDate() + 2)
    const startDiff = date - start;
    const endDiff = end - date
    if (startDiff >= 0 && endDiff >= 0) {
        return true
    } else {
        return false;
    }
    // console.log(date,"date",first,second);
    // console.log("difference isinrange",diffTime);
    // if (diffTime > 0) {
    //     const minutes = Math.round(diffTime / (60000 * 60))
    //     const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
    //     console.log("days isinrange", diffDays);
    //     if (diffDays > 0) return true
    //     return false;
    // }
    // return false
}